import useTableFilters from "@/hooks/useTableFilters";
import UserCombobox from "components/directus/combobox/user";
import ProjectCombobox from "components/directus/combobox/project";
import { EMPLOYEE_FILTERS } from "components/employee/constants";
import CalendarDatePicker from "ui/components/comp-507";
import { StatusMultiSelect } from "components/multi-select/status";
import { FilterActions } from "components/filter/actions";
import FilterWrapper from "components/filter/wrapper";
import FiltersList from "components/filter/list";
import TypeFilter from "components/job/type/filter";

export default function JobFilters({
  filters,
  setFilters,
  setIsOpen,
  isOpen,
  clearFilters,
  defaultFilters,
}) {
  const {
    localFilters,
    applyFilters,
    clearLocalFilters,
    handleSetLocalFilters,
  } = useTableFilters({
    filters,
    setFilters,
    setIsOpen,
    clearFilters,
    initialFilters: {
      coordinator: undefined,
      sales_coordinator: undefined,
      status: undefined,
      skills: undefined,
      ...defaultFilters,
    },
  });

  return (
    <FiltersList>
      <FilterWrapper label="Project">
        <ProjectCombobox
          value={localFilters.project?._eq}
          className="w-full"
          placeholder="Search and Select"
          searchPlaceholder="Search Project..."
          dependsOn={isOpen}
          onChange={(selectedItem) =>
            handleSetLocalFilters({
              ...localFilters,
              project: selectedItem ? { _eq: selectedItem } : undefined,
            })
          }
          hideLabel
        />
      </FilterWrapper>

      <FilterWrapper label="Job Coordinator">
        <UserCombobox
          value={localFilters?.coordinator?._eq}
          onChange={(selectedItem) => {
            handleSetLocalFilters({
              ...localFilters,
              coordinator: { _eq: selectedItem },
            });
          }}
          filter={EMPLOYEE_FILTERS.jobs_coordinating}
          dependenton={isOpen}
          placeholder="Search and Select"
          searchPlaceholder="Search Coordinators..."
        />
      </FilterWrapper>

      <FilterWrapper label="Status">
        <StatusMultiSelect
          collection="jobs"
          values={localFilters?.status?._in || []}
          onChange={(values) => {
            handleSetLocalFilters({
              ...localFilters,
              status: values.length
                ? { _in: values }
                : defaultFilters?.status,
            });
          }}
        />
      </FilterWrapper>

      <FilterWrapper label="Type">
        <TypeFilter
          value={localFilters?.type?._eq}
          onChange={(item) =>
            handleSetLocalFilters({
              ...localFilters,
              type: item ? { _eq: item } : undefined,
            })
          }
        />
      </FilterWrapper>

      <FilterWrapper label="Start Date">
        <CalendarDatePicker
          stack={true}
          date={{
            from: localFilters?.start_date?._gte,
            to: localFilters?.start_date?._lte,
          }}
          setDate={(range) => {
            handleSetLocalFilters({
              ...localFilters,
              start_date: {
                _gte: range?.from,
                _lte: range?.to,
              },
            });
          }}
          className="w-full"
        />
      </FilterWrapper>

      <FilterWrapper label="End Date">
        <CalendarDatePicker
          stack={true}
          date={{
            from: localFilters?.end_date?._gte,
            to: localFilters?.end_date?._lte,
          }}
          setDate={(range) => {
            handleSetLocalFilters({
              ...localFilters,
              end_date: {
                _gte: range?.from,
                _lte: range?.to,
              },
            });
          }}
          className="w-full"
        />
      </FilterWrapper>

      <FilterActions
        applyFilters={applyFilters}
        clearLocalFilters={clearLocalFilters}
      />
    </FiltersList>
  );
}
